import * as yup from 'yup';

// Week start day values: 0=Sunday, 1=Monday, 2=Tuesday, 3=Wednesday, 4=Thursday, 5=Friday, 6=Saturday
// Default is 1 (Monday)
export const householdSchema = yup.object({
  name: yup.string().required('Name is required'),  
  members: yup.number().min(1, 'Must have at least 1 member').required('Members are required'),
  week_start_day: yup.number().min(0).max(6).default(1), // 0=Sunday, 1=Monday, ..., 6=Saturday
});

export function newHousehold() {
  return {
    name: '',    
    members: 1,
    week_start_day: 1,
  }
}
